import React from 'react';
import { useReveal } from '../lib/useReveal';
const ITEMS = [{
  icon: '🌱',
  text: 'Desarrollo personal'
}, {
  icon: '💬',
  text: 'Consultas individuales'
}, {
  icon: '🤝',
  text: 'Sesiones complementarias'
}, {
  icon: '💻',
  text: 'Trabajo online'
}, {
  icon: '✨',
  text: 'Expansión profesional holística'
}, {
  icon: '🌿',
  text: 'Herramientas para acompañamiento emocional'
}];
export function CareerSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#faf3e3] py-5 md:py-10 px-5 sm:px-6 border-t border-[#2d3f2a]/5" data-id="element-36">
      <div className="container mx-auto max-w-4xl" data-id="element-37">
        <div ref={ref} className={`reveal ${vis ? 'is-visible' : ''}`} data-id="element-38">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#1e3a1e] text-center mb-6" data-id="element-39">
            Incorporá herramientas{' '}
            <span className="text-[#b8860b] italic" data-id="element-40">aplicables</span> en
            distintos contextos
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-41">
            {ITEMS.map((item, i) => <div key={i} className="flex items-center gap-4 bg-[#f5efe0] border border-[#2d3f2a]/10 rounded-xl p-5 hover:border-[#5a6b3f]/40 transition-all" data-id="element-42">
                <span className="text-2xl flex-shrink-0" data-id="element-43">{item.icon}</span>
                <p className="text-[#1e3a1e] text-sm sm:text-base font-medium leading-snug" data-id="element-44">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}